import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'isReplyMessageEmpty' })
export class IsReplyMessageEmptyPipe implements PipeTransform {
    transform(message: MessageDTO): boolean {
        if (message) {
            if (message.html && message.html.trim().length) {
                return false;
            }
            if (message.text && message.text.trim().length) {
                return false;
            }
            return true;
        } else {
            return true;
        }
    }
}
